"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParenthesisExprNode = void 0;
const tree_node_1 = require("../../custom_tree/base/tree.node");
const internal_node_1 = require("../base/internal.node");
const concrete_node_1 = require("../concrete.node");
class ParenthesisExprNode extends internal_node_1.InternalNode {
    constructor(originalNode, astParent) {
        super(originalNode, astParent);
        this._startPosition = originalNode.start.start;
        this._endPosition = originalNode.stop?.stop ?? originalNode.start.stop;
        this._treeNodeType = tree_node_1.TreeNodeType.PARENTHESIS_NODE;
    }
    accept(v) {
        if (v.visitParenthesisExpr)
            v.visitParenthesisExpr(this);
        this.visitChildren(v);
    }
    // this overrides get children to clean remaining concrete nodes from our AST (to be used on semantic validations)
    get children() {
        // this should return only one child (another expr)
        return this._children.filter(child => !(child instanceof concrete_node_1.ConcreteNode));
    }
    get rawChildren() {
        return this._children;
    }
    set children(children) {
        this._children = children;
    }
    getReturnType() {
        let realNode = this;
        // skip parenthesis nodes and get actual argument
        while (realNode instanceof ParenthesisExprNode) {
            // parenthesis node filter childrens on get method to return the expression
            realNode = realNode.children[0];
        }
        return realNode.getReturnType();
    }
}
exports.ParenthesisExprNode = ParenthesisExprNode;
